export default "__VITE_ASSET__6f9978ee__"